import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import CheckoutFooter from './CheckoutFooter';

import './styles.scss';

import { useProtectPaymentRoute } from './hooks/useProtectPaymentRoute';
import { CheckoutHeader } from './CheckoutHeader';
import { useGetCheckoutRoutesVerification } from '../hooks/useGetCheckoutRoutesVerification';
import { useEventContext } from '../provider';

export const CheckoutLayout = () => {
  const { isPaymentRoute, isPixRoute, isAtAnyInformationRoute } =
    useGetCheckoutRoutesVerification();

  useProtectPaymentRoute(isPaymentRoute);
  const { setInvalidFieldsNames } = useEventContext();

  useEffect(() => {
    setInvalidFieldsNames?.([]);
    const body = document.body;

    body.classList.add('fixed-body-no-scroll');
    return () => {
      body.classList.remove('fixed-body-no-scroll');
    };
  }, [setInvalidFieldsNames]);

  return (
    <Box
      display={{ base: 'block', md: 'flex' }}
      flexDirection="column"
      bg="white"
      className="checkout-divide">
      <Box
        display="flex"
        flexDir="column"
        position="fixed"
        top="0"
        bottom="0"
        left="0"
        right="0"
        overflow="hidden"
        className="content-wrapper">
        <CheckoutHeader />
        <Box
          display="flex"
          h="100%"
          px={{ base: '5', md: '0' }}
          overflow="auto"
          sx={{
            '&': {
              scrollbarColor: '#d1d1d1ae #ebebeb26',
              scrollbarWidth: 'thin',
            },
          }}
          className="checkout-container">
          <Box maxW="640px" mx="auto" flexGrow="1">
            <Outlet />
          </Box>
        </Box>

        {!isAtAnyInformationRoute && !isPixRoute && <CheckoutFooter />}
      </Box>
    </Box>
  );
};
